import type { FaireProductEntity } from "../../entity_types/product";

export const p_xeg8gsgsch: FaireProductEntity = {
  token: "p_xeg8gsgsch",
  type: "product",
  name: "Women's Valentine's Day Slim Notch Short Pajama Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/6af15e2aea2158f72b7aaa9263287ce2c72e36d38e2c851fbc9caf56472f210f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/618d7375aedf3515172c60dec59d6270ab4fb1e764837811d0ce5a9be15a01e3.png",
    "https://cdn.faire.com/fastly/0cf63133cdce63e18942632e478314e2791c06927a4d9c93fbe733da2e85b4c2.png",
    "https://cdn.faire.com/fastly/6102dd86453c639f31d08a04eecc23881d7f0c815381fb620f65486eeddaa9c4.png",
    "https://cdn.faire.com/fastly/c5fb6dea3fd5e17bcdc8ba0961bda9ee6094b1525c07ce317e6e6eb3f401a600.png"
  ],
  priceDollars: 60,
  description: "This dreamy Valentine’s Day PJ set brings a romantic twist to classic sleepwear with buttery-soft fabric designed for all-night comfort. The slim notch collar, functional button-down top, drawstring waist, and easy side pockets create a timeless silhouette that’s perfect for cozy nights, Valentine’s Day gifting, and self-care.\n\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Slim notch collar top\n• Long sleeve full button front\n• Wrapped in a Softies’ branded belly band\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• Easy care, colorfast and machine washable\n• Softies breathable Wellness Fabric is 96% modal, 4% spandex blend",
  tags: [],
  msrpDollars: 130,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:07.878Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
